<div class="p-6 max-w-5xl mx-auto">
  <div class="flex flex-row justify-between items-center mb-5">
    <div>
      <h1 class="text-2xl font-semibold mb-1">Send text message</h1>
      <p class="text-sm text-muted-color">User ID: {{ userId() }}</p>
    </div>
    <p-button icon="pi pi-arrow-left" label="Back" (onClick)="goBack()"></p-button>
  </div>

  <textarea
    pTextarea
    [value]="jsonInput()"
    (input)="onJsonInput($event)"
    aria-label="Notification JSON payload"
    class="w-full font-mono text-sm min-h-[220px]"
    rows="12"
  ></textarea>

  @if (validationError(); as error) {
    <p class="text-sm text-red-600 mt-2">{{ error }}</p>
  }

  @let details = validationDetails();
  @if (details.length > 0) {
    <ul class="mt-2 pl-5 list-disc text-sm text-red-600">
      @for (detail of details; track $index) {
        <li>
          <span class="font-mono">{{ detail.path }}</span>
          expected <span class="font-mono">{{ detail.expected }}</span>
        </li>
      }
    </ul>
  }

  @if (notificationId(); as createdId) {
    <div class="flex flex-row items-center gap-2 mt-3 text-sm">
      <span class="text-muted-color">Notification ID:</span>
      <span class="font-mono">{{ createdId }}</span>
      <homey-copy-button [value]="createdId"/>
    </div>
  }

  <div class="flex flex-row gap-2 mt-4">
    <homey-submit-button label="Send text message" [submitFunction]="sendTextMessage"></homey-submit-button>
    <p-button label="Reset JSON" icon="pi pi-undo" severity="secondary" (onClick)="resetJson()"></p-button>
  </div>
</div>
